import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS, AVATARS } from "@/data/content";
import { optimizeImg } from "@/lib/img";

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-32 bg-charcoal/40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-vitality">Real Results</span>
          <h2 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight mt-4 leading-tight">
            What AlphaPulse Users Say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
              className="relative bg-charcoal border border-white/10 rounded-2xl p-8 hover:border-vitality/40 transition-colors"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-vitality/15" />
              <div className="flex items-center gap-1 text-vitality mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="font-heading text-2xl font-bold uppercase tracking-tight leading-tight">"{t.quote}"</p>
              <p className="text-white/60 mt-3 leading-relaxed">{t.body}</p>
              <div className="flex items-center gap-3 mt-6 pt-6 border-t border-white/10">
                <img src={optimizeImg(AVATARS[t.avatar], 96)} alt={t.name} width="48" height="48" loading="lazy" decoding="async" className="w-12 h-12 rounded-full object-cover" />
                <div>
                  <div className="font-bold">{t.name}</div>
                  <div className="text-sm text-white/50">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
